import { get } from '@/utils/request';

export const carousels = (params) => {
  return get('/api/v1/carousels', params);
};
